var styles = {"listView":"styles_list-view__D6aVB","vertical":"styles_vertical__KqPE2","reverse":"styles_reverse__-E7I8","empty":"styles_empty__A8MHK","pending":"styles_pending__1ml8R","noSpacing":"styles_no-spacing__3byBS","compactSpacing":"styles_compact-spacing__XwdpH","comfortableSpacing":"styles_comfortable-spacing__xPYUM","looseSpacing":"styles_loose-spacing__OrBOJ"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
